// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-to-db-txt {\n    font-size: 12.5px;\n    color: grey;\n}", ""]);
// Exports
module.exports = exports;
